import { Injectable } from '@angular/core';
import { DataType } from '../data-type-component';
import { CurrencyDTO } from '../lottomart/model/lottomart-model';
import { AggFieldType, FieldConfigDTO, MoneyDTO } from '../../../../system/system-dtos';

@Injectable()
export class DataTypeAggsService {
  private aggMap: Map<AggFieldType, Map<DataType, (dataset: any[]) => any>> = new Map<
    AggFieldType,
    Map<DataType, (dataset: any[]) => any>
  >([
    [AggFieldType.SUM, new Map<DataType, (dataset: any[]) => string>([[DataType.money, this.sumMoney.bind(this)]])],
    [AggFieldType.AVG, new Map<DataType, (dataset: any[]) => string>([[DataType.money, this.avgMoney.bind(this)]])],
  ]);

  aggregate(aggType: AggFieldType, fieldConfig: FieldConfigDTO, data: any[]): any {
    if (this.aggMap.get(aggType) && this.aggMap.get(aggType).get(DataType[fieldConfig.type])) {
      const aggFunction = this.aggMap.get(aggType).get(DataType[fieldConfig.type]);
      const aggData = data.map((d) => d[fieldConfig.name]).filter((d) => d);

      return aggFunction(aggData);
    }
  }

  private sumMoney(dataset: MoneyDTO[]): string {
    const sum = dataset.reduce((a, b) => ({ currency: a.currency, value: a.value + b.value }));
    return `${this.moneyValueToString(sum.value, sum.currency)} ${sum.currency.code}`;
  }

  private avgMoney(dataset: MoneyDTO[]): string {
    const sum = dataset.reduce((a, b) => ({ currency: a.currency, value: a.value + b.value }));

    return `${this.moneyValueToString(sum.value / dataset.length, sum.currency)} ${sum.currency.code}`;
  }

  private moneyValueToString(value: number, currency: CurrencyDTO): string {
    const val: number = value / 10 ** currency.decimalPlaces;
    return val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
